import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-sq",
  "use": "icon-sq-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-sq\">\n<path d=\"M173.9,177.5H26.1c-4.1,0-7.4-3.3-7.4-7.4v-7.4c0-4.1,3.3-7.4,7.4-7.4h147.7c4.1,0,7.4,3.3,7.4,7.4v7.4\n\tC181.2,174.2,177.9,177.5,173.9,177.5z M173.9,111.1h-96c-4.1,0-7.4-3.3-7.4-7.4v-7.4c0-4.1,3.3-7.4,7.4-7.4h96\n\tc4.1,0,7.4,3.3,7.4,7.4v7.4C181.2,107.8,177.9,111.1,173.9,111.1z M173.9,44.6H26.1c-4.1,0-7.4-3.3-7.4-7.4v-7.4\n\tc0-4.1,3.3-7.4,7.4-7.4h147.7c4.1,0,7.4,3.3,7.4,7.4v7.4C181.2,41.3,177.9,44.6,173.9,44.6z M52,82.7v34.6c0,4.3-5.7,6.5-9,3.4\n\tl-19-17.3c-2.1-1.9-2.1-4.9,0-6.8l19-17.3C46.3,76.2,52,78.4,52,82.7L52,82.7z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/sq.svg
// module id = F50x
// module chunks = 166